import * as Sentry from '@sentry/react';

// An opaque per-tab support identifier; never derived from credentials or a QR.
let diagnosticId;
const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
function createId() {
  if (crypto.randomUUID) return crypto.randomUUID();
  const hex = Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
  return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
}
export function diagnosticTags(response) {
  if (!diagnosticId) {
    try {
      diagnosticId = sessionStorage.getItem('roamDiagnosticId');
      if (!uuid.test(diagnosticId || '')) {
        diagnosticId = createId();
        sessionStorage.setItem('roamDiagnosticId', diagnosticId);
      }
    } catch {
      diagnosticId = createId();
    }
  }
  const requestId = response?.headers?.['x-request-id'];
  return { diagnostic_id: diagnosticId, ...(uuid.test(requestId || '') ? { request_id: requestId } : {}) };
}

export function trackerOperation(config = {}) {
  try {
    const path = new URL(config.url, window.location.origin).pathname;
    const method = (config.method || 'get').toLowerCase();
    if (path === '/api/qrcode/register') return 'qr.register';
    if (path.startsWith('/api/qrcode/details/')) return 'qr.lookup';
    if (/^\/api\/qrcode\/[^/]+$/.test(path)) {
      if (method === 'delete') return 'qr.delete';
      if (method === 'put') return 'qr.edit';
    }
  } catch { /* Malformed URLs must not break error reporting. */ }
  return undefined;
}

export function reportValidationErrors(errors, stage) {
  const allowedFields = ['name', 'email', 'category', 'default_message', 'image', 'mobile_number', 'country_code'];
  const allowedReasons = ['required', 'pattern', 'fileType', 'fileSize', 'validate', 'minLength', 'maxLength'];
  const fields = allowedFields.filter(field => errors?.[field]);
  if (!fields.length) return;
  const reasons = fields.map(field => allowedReasons.includes(errors[field]?.type) ? errors[field].type : 'invalid');
  Sentry.captureMessage('Tracker validation blocked submission', {
    level: 'info', fingerprint: ['qr.validation', stage, fields.join(','), reasons.join(',')],
    tags: { ...diagnosticTags(), operation: 'qr.validation', stage,
      validation_fields: fields.join(','), validation_reasons: reasons.join(',') },
  });
}
